//
//
//
//
//
//
//

import $ from 'jquery';
export default {
  data(){
    return {
      num:'',
    }
  },
  methods:{
    getcicun(){
      this.$nextTick(function(){
        console.log(document.documentElement.clientWidth,document.documentElement.clientHeight,parseInt(document.documentElement.clientWidth/0.5633))

        if(parseInt(document.documentElement.clientWidth/0.5633) <document.documentElement.clientHeight){
          console.log(1)
          $('.xntk img').css({'width':'auto','height':document.documentElement.clientWidth/0.5633});
          $('.xntk img').css({'top':'50%','margin-top':(-document.documentElement.clientWidth/0.5633)/2 +'px','margin-left':-(parseInt($('.xntk img').css('width'))/2)+'px','left':'50%'});
        }else if(parseInt(document.documentElement.clientWidth/0.5633) >document.documentElement.clientHeight){
          console.log(2)
          $('.xntk img').css({'margin-top':'0px','top':'0%','width':(document.documentElement.clientHeight*0.5633)+"px",'left':'50%','margin-left':-(document.documentElement.clientHeight*0.5633)/2 +'px'});
          $('.xntk img').css('height',document.documentElement.clientHeight+'px');
        }else{
          console.log(3)
          $('.xntk img').css({'margin-right':'0px','right':'0%','margin-top':'0px','top':'0%','height':document.documentElement.clientWidth/0.5633});
        }
      });

    }
  },
  mounted(){
    this.$nextTick(function(){
      this.getcicun();
    });


    let _this = this;
    $(window).resize(function() {
      _this.getcicun();
    })
    let index =  this.$route.query.num.indexOf('.');
    if(index >0){
      this.num = this.$route.query.num;
    }else{
      this.num = 'tk'+ this.$route.query.num + '.jpg';
    }
  }
}



// WEBPACK FOOTER //
// ./src/project/articleProject/xntk2.vue